import styled from 'styled-components';

import Card from '../../Card';


export const StyledCard = styled(Card)`
  .nivocontainer {
    width: 100%;
    height: 280px;

    g text {
      fill: white !important;
    }
  }
  @media all and (max-width: 1024px) {
    h2.title {
      font-size: 22px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/DataCentre/LessonAttempts/LessonAttempts.styles.ts